import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TokenBalance } from '../components/companion/TokenBalance';
import { TokenPurchase } from '../components/companion/TokenPurchase';
import { TalkTimeAlert } from '../components/companion/TalkTimeAlert';
import { useAudioDetection } from '../hooks/useAudioDetection';
import { ComfortingMessages } from '../components/companion/ComfortingMessages';

export function CompanionPage() {
  const navigate = useNavigate();
  const { isListening } = useAudioDetection();

  return (
    <div className="relative w-full h-full">
      <div className="absolute inset-0 flex flex-col">
        <div className="flex-1 relative">
          <div
            className="absolute inset-0"
            style={{
              background: 'radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%)',
            }}
          />
          <div className="h-full">
            <iframe
              title="companion-chat"
              className="w-full h-full border-0 xs:h-[calc(345vh+20%)] sm:h-[calc(350vh+20%)]"
              style={{
                height: 'calc(345vh + 20%)'
              }}
            />
          </div>
        </div>

        <div className="relative">
          <TokenBalance />
          <TokenPurchase />
          <TalkTimeAlert isListening={isListening} />
          <ComfortingMessages />
        </div>
      </div>
    </div>
  );
}